import React from "react";
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { fmtCurrency } from "@/lib/format";

const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="p-3 text-xs" style={{ background: "var(--bg)", border: "1px solid var(--border)" }}>
      <p className="label-xs mb-1">{label}</p>
      <p style={{ color: "var(--gain)" }}>{fmtCurrency(payload[0].value)}</p>
    </div>
  );
};

export default function ProjectedIncomeChart({ data }) {
  const chartData = (data?.months || []).map((m) => ({ month: m.month.split(" ")[0], amount: m.amount }));

  return (
    <div className="card" data-testid="projected-income-chart">
      <div className="flex items-baseline justify-between mb-6">
        <div>
          <p className="label-xs mb-1">Forecast / 12 months</p>
          <h3 className="font-serif text-2xl">Projected dividend income</h3>
        </div>
        <p className="font-mono text-xs" style={{ color: "var(--text-secondary)" }}>
          monthly avg <span style={{ color: "var(--gain)" }}>{fmtCurrency(data?.monthly_avg || 0)}</span>
        </p>
      </div>

      {chartData.length === 0 || (data?.annual || 0) === 0 ? (
        <div className="h-[260px] flex items-center justify-center text-xs" style={{ color: "var(--text-secondary)" }}>
          Add dividend-paying holdings to see the forecast.
        </div>
      ) : (
        <div style={{ width: "100%", height: 260 }}>
          <ResponsiveContainer>
            <BarChart data={chartData} margin={{ top: 10, right: 0, left: 0, bottom: 0 }}>
              <CartesianGrid stroke="#1E293B" strokeDasharray="2 4" vertical={false} />
              <XAxis
                dataKey="month"
                stroke="#8B9BB4"
                tick={{ fill: "#8B9BB4", fontSize: 10, fontFamily: "JetBrains Mono" }}
                axisLine={{ stroke: "#1E293B" }}
                tickLine={false}
              />
              <YAxis
                stroke="#8B9BB4"
                tick={{ fill: "#8B9BB4", fontSize: 10, fontFamily: "JetBrains Mono" }}
                axisLine={false} tickLine={false}
                tickFormatter={(v) => `$${v.toFixed(0)}`}
                width={50}
              />
              <Tooltip content={<CustomTooltip />} cursor={{ fill: "rgba(0,230,118,0.05)" }} />
              <Bar dataKey="amount" fill="#00E676" radius={0} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
